import BlockType17 from '@headlines/components/block/11-20/BlockType17.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType17: AdminBlockType = {
  component: BlockType17,
  attributes: AdminBlockTypeAttributes({
    icons: true,
    author: true,
    titleComment: true,
    channel: true,
    category: true,
    lead: false,
  }),
  articlesCount: 2,
};

export default AdminBlockType17;
